import { StorageTranscoder } from './web-storage.model';

export class JsonStorageTranscoder<T> implements StorageTranscoder<T> {
  encode(value: T): string {
    return JSON.stringify(value);
  }

  decode(value: string): T {
    return JSON.parse(value);
  }
}

export class StringStorageTranscoder implements StorageTranscoder<string> {
  encode(value: string): string {
    return value;
  }

  decode(value: string): string {
    return value;
  }
}

export const STORAGE_TRANSCODERS = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  JSON: new JsonStorageTranscoder() as StorageTranscoder<any>,
  STRING: new StringStorageTranscoder() as StorageTranscoder<string>,
};
